import { RouteObject } from "react-router-dom";
import DriverLayout from "../../layout/DriverLayout";
import CompleteInfo from "../../pages/Driver/CompleteInfo";
import SuportPage from "../../pages/Driver/SuportPage";
import SendTicketPage from "../../pages/Driver/SendTicketPage";
import ProfilePage from "../../pages/Driver/Profile";
import SettingsPage from "../../pages/Driver/Settings";
import NotifsPage from "../../pages/Driver/Notifs";
import CheckInPage from "../../pages/Driver/CheckIn";
import TurnDetails from "../../pages/Driver/CheckIn/TurnDetails";
import WalletPage from "../../pages/Driver/wallet";
import CommunicateCompanies from "../../pages/Driver/CommunicateCompanies";
import CoursesPage from "../../pages/Driver/KarenClub/Courses";
import DashboardPage from "../../pages/Driver/Dashboard";
import KarenClubPage from "../../pages/Driver/KarenClub";
import GetFreight from "../../pages/Driver/GetFreight";
import ManageFreights from "../../pages/Driver/ManageFreight";
import EditProfile from "../../pages/Driver/Profile/EditProfile";
import WithdrawWallet from "../../pages/Driver/WithdrawWallet";

const driverRoutes: RouteObject[] = [
  {
    path: "/driver",
    element: <DriverLayout />,
    children: [
      {
        path: "dashboard",
        element: <DashboardPage />,
      },
      {
        path: "get-freight",
        element: <GetFreight />,
      },
      {
        path: "manage-freight",
        element: <ManageFreights />,
      },
      {
        path: "complete-info",
        element: <CompleteInfo />,
      },
      {
        path: "suport",
        element: <SuportPage />,
      },
      {
        path: "suport/new-ticket",
        element: <SendTicketPage />,
      },
      {
        path: "communicate-companies",
        element: <CommunicateCompanies />,
      },
      {
        path: "profile",
        element: <ProfilePage />,
      },
      {
        path: "edit-profile",
        element: <EditProfile />,
      },
      {
        path: "notifications",
        element: <NotifsPage />,
      },
      {
        path: "settings",
        element: <SettingsPage />,
      },
      {
        path: "check-in",
        element: <CheckInPage />,
      },
      {
        path: "check-in/:turnId",
        element: <TurnDetails />,
      },
      {
        path: "wallet",
        element: <WalletPage />,
      },
      {
        path: "withdraw-wallet",
        element: <WithdrawWallet />,
      },
      {
        path: "karenclub",
        element: <KarenClubPage />,
      },
      {
        path: "karenclub/courses",
        element: <CoursesPage />,
      },
    ],
  },
];

export default driverRoutes;
